import React from 'react';
import { Check } from 'lucide-react';
import { LABEL, slug } from './quoteOptions';

// Pill chips. multiple=true → value is an array; otherwise a string.
export default function ChoiceChips({ label, name, options, value, onChange, multiple = false, error, required = false }) {
  const selected = (o) => (multiple ? value.includes(o) : value === o);
  const toggle = (o) => {
    if (!multiple) return onChange(value === o ? '' : o);
    return onChange(value.includes(o) ? value.filter((x) => x !== o) : [...value, o]);
  };
  return (
    <fieldset data-testid={`quote-${name}`}>
      <legend className={LABEL}>
        {label}{required && ' *'}
        {multiple && <span className="ml-2 normal-case tracking-normal text-[#7a7a7a] font-normal">(pick any)</span>}
      </legend>
      <div className="flex flex-wrap gap-2">
        {options.map((o) => (
          <button
            type="button"
            key={o}
            onClick={() => toggle(o)}
            aria-pressed={selected(o)}
            className={`inline-flex items-center gap-1.5 rounded-full px-4 py-2 text-sm border transition-colors duration-150 ${
              selected(o) ? 'bg-[#00b8ff] text-black border-[#00b8ff] font-semibold' : 'border-white/15 text-[#f4efe6] hover:border-[#00b8ff]'
            }`}
            data-testid={`quote-${name}-${slug(o)}`}
          >
            {selected(o) && multiple && <Check className="w-3.5 h-3.5" />}
            {o}
          </button>
        ))}
      </div>
      {error && <p className="text-xs text-red-400 mt-2" data-testid={`quote-${name}-error`}>{error}</p>}
    </fieldset>
  );
}
